var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { JSONStruct, nullable, property } from 'badphraim/data/JSONStruct';
export class ewUpdateMemberInfoResult extends JSONStruct {
    constructor() {
        super(...arguments);
        /** @override */ this.address = '';
        /** @override */ this.date_of_birth = '';
        /** @override */ this.email = '';
        /** @override */ this.firstname = '';
        /** @override */ this.gender = '';
        /** @override */ this.lastname = '';
        /** @override */ this.memberId = 0;
        /** @override */ this.municipality = '';
        /** @override */ this.phone_number = '';
        /** @override */ this.postal_code = '';
    }
}
__decorate([
    property,
    __metadata("design:type", String)
], ewUpdateMemberInfoResult.prototype, "address", void 0);
__decorate([
    nullable,
    __metadata("design:type", Boolean)
], ewUpdateMemberInfoResult.prototype, "approve_tos", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewUpdateMemberInfoResult.prototype, "date_of_birth", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewUpdateMemberInfoResult.prototype, "email", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewUpdateMemberInfoResult.prototype, "firstname", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewUpdateMemberInfoResult.prototype, "gender", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewUpdateMemberInfoResult.prototype, "lastname", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], ewUpdateMemberInfoResult.prototype, "memberId", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewUpdateMemberInfoResult.prototype, "municipality", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewUpdateMemberInfoResult.prototype, "phone_number", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewUpdateMemberInfoResult.prototype, "postal_code", void 0);
